import { ReactNode } from 'react'
import { ContentCollapsible } from './ContentCollapsible'
import { Paragraph } from '../../core/typography/Paragraph'
import { Style } from 'inlines'

export type ParagraphCollapsibleProps = {
  children: ReactNode
  truncateAfter?: number
  style?: Style
}

export const ParagraphCollapsible = ({
  children,
  truncateAfter,
  style,
}: ParagraphCollapsibleProps) => {
  return (
    <ContentCollapsible truncateAfter={truncateAfter}>
      <Paragraph.Medium data-testid="paragraphCollapsible" style={{ ...style }}>
        {children}
      </Paragraph.Medium>
    </ContentCollapsible>
  )
}
